import { throttle } from 'throttle-debounce'
import { Rive } from '@rive-app/canvas'
import { isInView } from '../utilities/helpers'

import { resizeCanvas } from '../utilities/riveHelpers'

let listenIcons = []

const initRive = () => {
  const riveElements = document.getElementsByClassName('js-rive')

  if (riveElements) {
    Array.from(riveElements).forEach((canvasEl) => {
      const { src } = canvasEl.dataset

      const riveAnimation = new Rive({
        src: src,
        canvas: canvasEl,
        autoplay: false,
        stateMachines: 'state',
        onLoad: () => {
          // Hide the animation by default to prevent any flash (we show it once it's in view later)
          riveAnimation.canvas.classList.add('invisible')

          // Push so we can check using a single scroll listener
          listenIcons.push(riveAnimation)

          // Once all the icons have been initialised, check if they need triggering
          if (listenIcons.length === riveElements.length) {
            triggerAnimationInView()
          }

          // Get the inputs via the name of the state machine
          const inputs = riveAnimation.stateMachineInputs('state')

          // Add hover events if "hover" input detected
          if (inputs && inputs.length) {
            const hoverTrigger = inputs.find((i) => i.name === 'hover')

            if (hoverTrigger) {
              canvasEl.addEventListener('mouseenter', () => {
                hoverTrigger.value = 1
              })

              canvasEl.addEventListener('mouseleave', () => {
                hoverTrigger.value = 0
              })

              canvasEl.addEventListener('mouseleave', () => {
                hoverTrigger.value = 0
              })
            }
          }

          // Add width and height attributes to the canvas element and resize the internal canvas resolution
          resizeCanvas(riveAnimation)
        },
      })
    })
  }

  const triggerAnimationInView = throttle(100, () => {
    if (!listenIcons.length) return

    // Check if each icon is in view and trigger the animation if true
    for (let i = 0; i < listenIcons.length; i++) {
      const riveAnimation = listenIcons[i]
      const canvasEl = riveAnimation.canvas
      const inView = isInView(canvasEl) && canvasEl.offsetParent !== null;

      // Optionally use the animation name from the data attribute
      let animationName = canvasEl.dataset.animationName ?? false;

      // Otherwise set the animation name based on the class
      if( !animationName ) {
        riveAnimation.animationNames.includes('intro-animation') &&
        riveAnimation.canvas.classList.contains('js-play-intro')
          ? 'state'
          : 'idle'
      }

      if (inView && !riveAnimation.isPlaying) {
        // Show and start animation
        riveAnimation.canvas.classList.remove('invisible')
        riveAnimation.play(animationName)

        // Resize canvas in case element was previously hidden
        resizeCanvas(riveAnimation)
      } else if (!inView && riveAnimation.isPlaying) {
        riveAnimation.canvas.classList.add('invisible')
        riveAnimation.pause(animationName)
      }
    }
  })

  window.addEventListener('scroll', triggerAnimationInView);
  window.addEventListener('resize', triggerAnimationInView);
}

export default initRive
